import { render, staticRenderFns } from "./browserdownload.vue?vue&type=template&id=9c5ae834&scoped=true&"
import script from "./browserdownload.vue?vue&type=script&lang=js&"
export * from "./browserdownload.vue?vue&type=script&lang=js&"
import style0 from "./browserdownload.vue?vue&type=style&index=0&id=9c5ae834&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5ae834",
  null
  
)

export default component.exports